import request from '@/utils/request'

//门票信息
export function visitInfo(data) {
    return request({
      url: `/Exhibition/GetMemberVisitInfoByMobile`,
      method: 'post',
      data
    })
}

//预登记信息（以前记录）
export function beforeInfo(data) {
    return request({
      url: `/Exhibition/GetBeforeExhibitionVisitInfo`,
      method: 'post',
      data,
      isHasErrorOther: true
    })
}

//职业列表
export function dutyList(data) {
  return request({
    url: `/Exhibition/GetVisitMemberDutyList`,
    method: 'post',
    data
  })
}

//问卷列表
export function questionList(data) {
    return request({
      url: `/Exhibition/GetGymfQuestionList`,
      method: 'post',
      data
    })
}

//资料验证
export function checkInfo(data) {
    return request({
      url: `/Exhibition/CheckExhibitionVisitInfo`,
      method: 'post',
      data
    })
}

//添加预登记信息
export function addRecords(data) {
    return request({
      url: `/Exhibition/AddExhibitionVisitRecords`,
      method: 'post',
      data
    })
}

//渠道访问次数
export function addViews(data) {
  return request({
    url: `/Exhibition/AddExhibitionVisitChannelViews`,
    method: 'post',
    data,
    isHasErrorOther: true
  })
}
